import { default as Common } from './modules/common.js';
import { default as Accordion } from './modules/accordion.js';
import { default as Animation } from './modules/animation.js';
import { default as Clipboard } from './modules/clipboard.js';
import { default as Collapse } from './modules/collapse.js';
import { default as Sliders } from './modules/sliders.js';
import { default as Search } from './modules/search.js';

const modules = {
	Common,
	Accordion,
	Animation,
	Clipboard,
	Collapse,
	Sliders,
	Search,
};

Object.keys(modules).forEach(key => {
	modules[key].init();
	window[key] = modules[key];
});